import { QuantityType } from "@/core/api/apiClient";

const mapping: Record<QuantityType, string> = {
  Loads: "Loads",
  Tons: "Tons",
  Yards: "Yards"
};

export function mapQuantityType(key: QuantityType | string): string {
  return mapping[key as QuantityType] ?? key;
}

export default mapQuantityType;
